import Button from "@components/library/Button";
import { useBreakpoints } from "hooks/useBreakpoints";
import Image from "next/image";
import { AuthorFrontMatter } from "types/AuthorFrontMatter";
import Link from "./Link";

export const AuthorSection = ({ author }: { author: AuthorFrontMatter }) => {
  const { isSmallWidth, isMediumWidth } = useBreakpoints();

  let imageWidth: number;
  if (!isSmallWidth) {
    imageWidth = 96;
  } else if (!isMediumWidth) {
    imageWidth = 160;
  } else {
    imageWidth = 290;
  }

  return (
    <div className="dark bg-black pb-32 md:pb-[52px]">
      <div className="container-xl md:py-52">
        <h3 className="flex py-40 text-14-16 font-bold dark:text-white">
          About the author
        </h3>

        <div className="flex items-center gap-24 md:justify-center md:gap-40">
          {author.avatar && (
            <Image
              src={author.avatar}
              width={imageWidth}
              height={imageWidth}
              alt="avatar"
              className="flex-none"
              style={{
                maxWidth: "100%",
                height: "auto"
              }} />
          )}
          <div className="max-w-md">
            <dl>
              <dt className="sr-only">Name</dt>
              <dd className="font-display text-24-32 font-bold text-gray-900 dark:text-white">
                {author.name}
              </dd>
            </dl>
            <dl>
              <dt className="sr-only">Role</dt>
              <dd className="mt-4 text-14-20 font-bold text-gray-900 dark:text-gray-600">
                {author.occupation}
              </dd>
            </dl>
            <div className="mt-24 hidden text-14-24 dark:text-white md:block">
              {author.bio}
            </div>
            <dl className="">
              <dt className="sr-only">Twitter</dt>
              <dd>
                {author.twitter && (
                  <Button
                    styling="link"
                    href={author.twitter}
                    target="_blank"
                    className="-ml-12 mt-12"
                  >
                    {author.twitter.replace("https://twitter.com/", "@")}
                  </Button>
                )}
              </dd>
            </dl>
          </div>
        </div>
        <div className="mt-24 text-13-20 dark:text-white md:hidden md:text-14-24">
          {author.bio}
        </div>
      </div>
    </div>
  );
};
